export enum QuestionSortKeyEnum {
  BUSINESS_KEY = 'businessKey',
  UPDATED_AT = 'updatedAt',
  VERSION_NO = 'versionNo',
}
